module.exports = __webpack_public_path__ + "img/电梯动画19.d678b41e.png";